export default {
    WOMENS: "Womens",
    MENS: "Mens",
    FOOTWEAR: "Footwear",
    ACCESSORIES: "Accessories",
    SPORTS_OUTDOORS: "Sports & Outdoors",
    KIDS: "Kids",
    BEAUTY: "Beauty",
    HOME_GARDEN: "Home & Garden",
    ELECTRONICS: "Electronics",
    FOOD_BEVERAGE: "Food & Beverage",
    AUTOMOTIVE: "Automotive",
};
